export enum EmploymentType {
	permanent = "permanent",
	temporary = "temporary",
	fixed_term = "fixed_term",
	fixed_term_with_option_for_permanent = "fixed_term_with_option_for_permanent",
	freelance = "freelance",
	traineeship = "traineeship",
	internship = "internship",
}

export enum SalaryPeriod {
	hourly = "hourly",
	monthly = "monthly",
	yearly = "yearly",
}
